import clsx from "clsx"
export default function Close({ className = '' }) {
  return (
    <svg className={clsx(className, 'w-(--space-7) h-auto')} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 4L4 20M4 4L20 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
